import React from "react";
import { videoData } from "../../Data/Help/HelpVideos";
import { UL, LI, H6,H5, P } from "../../AbstractElements";
import { CardBody,Card } from "reactstrap";
const VideosDetails = () => {
  const filelist = videoData.map((data, i) => {
    return (
      <LI attrLI={{ className: "file-box" }} key={i}>
        <div className="file-top">
            <div>
            <i className={data.icon}></i>
            </div>
        </div>
        <div className="file-bottom">
          <H6>{data.name}</H6>
          <P attrPara={{ className: "mb-0 mt-1" }}>{data.summary}</P>
        </div>
        <div className="file-download">
          <button className="btn">Download <i className="fa fa-download"></i></button>
        </div>
      </LI>
    );
  });
  return (
    <div className="file-content">
        {filelist.length ? (
          <CardBody className="file-manager">
            <UL attrUL={{ className: "simple-list files" }}> {filelist}</UL>
          </CardBody>
        ) : (
          <div>Empty Data</div>
        )}
  
    </div>
  );
};

export default VideosDetails;

